<div
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm transition-opacity duration-300"
  [ngClass]="isClosing ? 'opacity-0' : 'opacity-100'"
  (click)="closeDropdowns()"
>
  <div
    class="relative w-full max-w-6xl max-h-[95vh] bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 flex flex-col overflow-hidden transition-all duration-300"
    [ngClass]="
      isClosing
        ? 'opacity-0 translate-y-8 scale-95'
        : 'opacity-100 translate-y-0 scale-100 animate-fade-in-up'
    "
    (click)="onClickInsideModal($event)"
  >
    <!-- Header -->
    <div
      class="flex-none px-6 md:px-8 py-5 border-b border-slate-100 dark:border-slate-800 flex justify-between items-center gap-4"
    >
      <div>
        <h3
          class="text-xl md:text-2xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2"
        >
          <span class="material-icons text-amber-500">badge</span>
          {{
            isQuotaCreate
              ? "ออกบัตร Platform (โควต้า)"
              : isQuotaEdit
                ? "แก้ไขบัตร Platform (โควต้า)"
                : isCreate
                  ? "สร้างบัตรจอดรถ"
                  : mode === "edit"
                    ? "แก้ไขข้อมูลบัตรจอดรถ"
                    : "ข้อมูลบัตรจอดรถ"
          }}
          <div
            *ngIf="isLoading"
            class="w-5 h-5 border-2 border-slate-200 dark:border-slate-700 border-t-amber-400 rounded-full animate-spin"
          ></div>
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 font-medium">
          {{
            isQuotaCreate
              ? "กรอกข้อมูลสมาชิกและหักโควต้า Platform"
              : isQuotaEdit
                ? "แก้ไขข้อมูลสมาชิก ทะเบียนรถ และสิทธิ์เข้า-ออก"
                : isCreate
                  ? "กรอกข้อมูลผู้ใช้และสิทธิ์การเข้า-ออก"
                  : "รายละเอียดบัตรจอดรถ"
          }}
        </p>
        <div
          *ngIf="isQuotaCreate && activeClientQuota"
          class="mt-2 inline-flex items-center gap-2 px-3 py-1.5 rounded-xl text-xs font-bold"
          [ngClass]="
            activeClientQuota.quotaRemaining > 0
              ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
              : 'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400'
          "
        >
          <span class="material-icons text-sm">account_balance_wallet</span>
          ออกได้อีก {{ activeClientQuota.quotaRemaining }} ใบ (จาก
          {{ activeClientQuota.quotaApproved }})
        </div>
      </div>
      <button
        (click)="closeModal()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors"
      >
        <span class="material-icons">close</span>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 overflow-y-auto px-4 md:px-8 py-6 custom-scrollbar">
      <div
        class="bg-white/95 dark:bg-slate-900/95 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-800 overflow-hidden"
      >
        <div
          *ngIf="isWizardMode"
          class="bg-slate-50/80 dark:bg-slate-800/40 border-b border-slate-100 dark:border-slate-800 px-4 md:px-6 py-3"
        >
          <div class="grid grid-cols-2 md:grid-cols-4 gap-2">
            <button
              type="button"
              *ngFor="let s of wizardSteps; let i = index"
              (click)="goWizardStep(i)"
              [disabled]="isQuotaCreate && clientId <= 0 && i > 0"
              class="rounded-xl border px-3 py-2 text-left transition-all flex items-center gap-2.5 disabled:opacity-50 disabled:cursor-not-allowed"
              [ngClass]="
                wizardIndex === i
                  ? 'border-amber-400 bg-amber-50 dark:bg-amber-950/30'
                  : wizardIndex > i
                    ? 'border-emerald-200 bg-emerald-50/50 dark:bg-emerald-950/20'
                    : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900'
              "
            >
              <span
                class="w-7 h-7 rounded-full flex items-center justify-center text-xs font-black shrink-0"
                [ngClass]="
                  wizardIndex === i
                    ? 'bg-amber-400 text-white'
                    : wizardIndex > i
                      ? 'bg-emerald-500 text-white'
                      : 'bg-slate-100 dark:bg-slate-800 text-slate-400'
                "
              >
                <span *ngIf="wizardIndex > i" class="material-icons text-[16px]"
                  >check</span
                >
                <ng-container *ngIf="wizardIndex <= i">{{
                  i + 1
                }}</ng-container>
              </span>
              <span class="min-w-0">
                <span class="block text-[11px] font-bold text-slate-400"
                  >ขั้น {{ i + 1 }}</span
                >
                <span
                  class="block text-xs font-extrabold text-slate-800 dark:text-slate-100 truncate"
                  >{{ s.label }}</span
                >
              </span>
            </button>
          </div>
        </div>

        <div
          *ngIf="!isWizardMode"
          class="h-14 bg-slate-50/80 dark:bg-slate-800/40 border-b border-slate-100 dark:border-slate-800 px-4 md:px-6 flex justify-between items-center"
        >
          <div class="flex gap-2 overflow-x-auto">
            <button
              *ngFor="let t of visibleTabs"
              type="button"
              (click)="setTab(t.id)"
              class="px-5 py-2 text-sm font-bold rounded-full whitespace-nowrap transition-all"
              [disabled]="isQuotaCreate && clientId <= 0 && t.id !== 'userInfo'"
              [ngClass]="
                activeTab === t.id
                  ? 'bg-amber-400 text-white shadow-md shadow-amber-200/50 dark:shadow-amber-900/30'
                  : 'bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-slate-100'
              "
            >
              {{ t.label }}
            </button>
          </div>
          <div
            class="flex items-center gap-2 px-3 py-1.5 bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-slate-600 dark:text-slate-300 shrink-0"
          >
            <span class="material-icons text-[18px] text-amber-500"
              >directions_car</span
            >
            <span class="text-xs font-bold"
              >{{ getActiveVehicles().length }} ทะเบียน</span
            >
          </div>
        </div>

        <div class="px-4 md:px-8 py-6 md:py-8 min-h-[420px] relative">
          <div
            *ngIf="isLoading"
            class="absolute inset-0 z-10 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs flex items-center justify-center rounded-2xl"
          >
            <div
              class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"
            ></div>
          </div>

          <!-- Tab: ข้อมูลผู้ใช้ -->
          <div
            *ngIf="activeTab === 'userInfo'"
            class="w-full space-y-5 animate-fade-in"
          >
            <!-- Client (required, searchable) -->
            <div class="relative z-20">
              <label
                class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2"
              >
                ร้าน / บริษัท <span class="text-rose-500">*</span>
              </label>
              <div
                data-field="client"
                class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]"
                [class.field-invalid]="isInvalid('client')"
              >
                <span class="absolute left-3 material-icons text-slate-400"
                  >store</span
                >
                <input
                  type="text"
                  [(ngModel)]="clientSearchText"
                  (focus)="openClientDropdown()"
                  (input)="onClientSearchInput()"
                  (blur)="closeClientDropdown()"
                  [readonly]="isClientFieldReadOnly"
                  placeholder="ค้นหาและเลือกร้าน..."
                  class="w-full pl-10 pr-10 py-2 bg-transparent border-none text-sm font-medium focus:outline-none"
                  [ngClass]="
                    isClientFieldLocked
                      ? 'cursor-default text-slate-600 dark:text-slate-300'
                      : ''
                  "
                />
                <button
                  *ngIf="clientId && !isClientFieldReadOnly"
                  type="button"
                  (mousedown)="$event.preventDefault(); clearClient()"
                  class="absolute right-3 top-2 text-slate-400 hover:text-rose-500"
                >
                  <span class="material-icons text-lg">close</span>
                </button>
              </div>
              <p *ngIf="isInvalid('client')" class="field-error-text">
                <span class="material-icons text-sm">error</span>
                กรุณาเลือกร้าน / บริษัท
              </p>
              <p
                *ngIf="isClientFieldLocked"
                class="text-xs text-amber-600 dark:text-amber-400 mt-1.5 flex items-center gap-1"
              >
                <span class="material-icons text-sm">lock</span>
                ล็อกตามสิทธิ์ร้านของคุณ
              </p>
              <p
                *ngIf="isQuotaEdit"
                class="text-xs text-slate-500 dark:text-slate-400 mt-1.5 flex items-center gap-1"
              >
                <span class="material-icons text-sm">lock</span>
                ไม่สามารถเปลี่ยนร้านเมื่อแก้ไขบัตร
              </p>
              <button
                *ngIf="isClientDropdownOpen && !isClientFieldReadOnly"
                type="button"
                class="fixed inset-0 z-30 cursor-default"
                (click)="closeClientDropdown()"
              ></button>
              <div
                *ngIf="isClientDropdownOpen && !isClientFieldReadOnly"
                class="absolute top-full mt-2 left-0 right-0 max-h-52 overflow-y-auto bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 z-40"
              >
                <button
                  *ngFor="let c of clientDropdownOptions"
                  type="button"
                  (mousedown)="$event.preventDefault(); selectClient(c)"
                  class="w-full text-left px-4 py-2.5 text-sm font-medium text-slate-700 dark:text-slate-200 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 transition-colors"
                >
                  {{ c.name }}
                </button>
                <div
                  *ngIf="clientDropdownOptions.length === 0"
                  class="px-4 py-3 text-sm text-slate-400"
                >
                  ไม่พบร้านที่ค้นหา
                </div>
                <div
                  *ngIf="!clientSearchText.trim() && clients.length > 20"
                  class="px-4 py-2 text-xs text-slate-400 border-t border-slate-100 dark:border-slate-700"
                >
                  แสดง 20 รายการแรก — พิมพ์เพื่อค้นหาเพิ่ม
                </div>
              </div>
            </div>

            <!-- สรุปโควต้า -->
            <div
              *ngIf="
                isQuotaContext && (isLoadingClientQuota || activeClientQuota)
              "
              class="space-y-3"
            >
              <div
                *ngIf="isLoadingClientQuota"
                class="p-4 rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 flex items-center gap-3 text-sm text-slate-500"
              >
                <div
                  class="w-5 h-5 border-2 border-amber-400 border-t-transparent rounded-full animate-spin"
                ></div>
                กำลังโหลดโควต้าร้าน...
              </div>
              <div
                *ngIf="!isLoadingClientQuota && activeClientQuota"
                class="p-5 rounded-2xl border border-emerald-200/70 dark:border-emerald-800/50 bg-emerald-50/50 dark:bg-emerald-900/20"
              >
                <h4
                  class="text-sm font-bold text-emerald-800 dark:text-emerald-300 flex items-center gap-2 mb-4"
                >
                  <span class="material-icons text-base"
                    >account_balance_wallet</span
                  >
                  โควต้าที่ใช้ออกบัตร — {{ activeClientQuota.name }}
                  <span
                    class="text-xs font-semibold px-2 py-0.5 rounded-lg bg-white/80 dark:bg-slate-800 text-emerald-700 dark:text-emerald-400"
                  >
                    {{ quotaLevelLabel(activeClientQuota.quotaLevel) }}
                  </span>
                </h4>
                <div class="grid grid-cols-3 gap-3">
                  <div
                    class="p-3 rounded-xl bg-white/80 dark:bg-slate-800/80 border border-slate-100 dark:border-slate-700 text-center"
                  >
                    <div class="text-xs text-slate-400 font-bold uppercase">
                      อนุมัติ
                    </div>
                    <div
                      class="text-2xl font-black text-slate-800 dark:text-slate-100"
                    >
                      {{ activeClientQuota.quotaApproved }}
                    </div>
                  </div>
                  <div
                    class="p-3 rounded-xl bg-white/80 dark:bg-slate-800/80 border border-slate-100 dark:border-slate-700 text-center"
                  >
                    <div class="text-xs text-slate-400 font-bold uppercase">
                      ใช้แล้ว
                    </div>
                    <div
                      class="text-2xl font-black text-slate-800 dark:text-slate-100"
                    >
                      {{ activeClientQuota.quotaUsed }}
                    </div>
                  </div>
                  <div
                    class="p-3 rounded-xl text-center border"
                    [ngClass]="
                      activeClientQuota.quotaRemaining > 0
                        ? 'bg-emerald-100/80 dark:bg-emerald-900/30 border-emerald-200 dark:border-emerald-800'
                        : 'bg-rose-50 dark:bg-rose-900/20 border-rose-200 dark:border-rose-800'
                    "
                  >
                    <div
                      class="text-xs font-bold uppercase"
                      [ngClass]="
                        activeClientQuota.quotaRemaining > 0
                          ? 'text-emerald-600'
                          : 'text-rose-600'
                      "
                    >
                      คงเหลือออกได้
                    </div>
                    <div
                      class="text-2xl font-black"
                      [ngClass]="
                        activeClientQuota.quotaRemaining > 0
                          ? 'text-emerald-700 dark:text-emerald-400'
                          : 'text-rose-600'
                      "
                    >
                      {{ activeClientQuota.quotaRemaining }}
                    </div>
                  </div>
                </div>
                <p
                  *ngIf="isQuotaCreate && activeClientQuota.quotaRemaining <= 0"
                  class="text-xs text-rose-600 dark:text-rose-400 mt-3 flex items-center gap-1"
                >
                  <span class="material-icons text-sm">error</span>
                  โควต้าหมดแล้ว — ไม่สามารถออกบัตรเพิ่มได้
                </p>
              </div>
            </div>

            <div
              *ngIf="requiresClientFirst"
              class="p-5 rounded-2xl border border-dashed border-amber-300 dark:border-amber-700 bg-amber-50/40 dark:bg-amber-900/10 text-center"
            >
              <span class="material-icons text-3xl text-amber-500 mb-2"
                >store</span
              >
              <p class="text-sm font-bold text-amber-800 dark:text-amber-300">
                กรุณาเลือกร้านก่อน
              </p>
              <p class="text-xs text-amber-700/80 dark:text-amber-400/80 mt-1">
                ระบบจะแสดงจำนวนโควต้าที่ออกได้
                แล้วจึงกรอกข้อมูลสมาชิกและทะเบียนรถ
              </p>
            </div>

            <ng-container *ngIf="canProceedQuotaForm">
              <!-- LINE (ไม่บังคับ) -->
              <div
                class="rounded-2xl border transition-colors"
                [ngClass]="
                  hasLine
                    ? 'border-emerald-200 dark:border-emerald-800/60 bg-emerald-50/40 dark:bg-emerald-900/10'
                    : 'border-slate-100 dark:border-slate-700 bg-slate-50/60 dark:bg-slate-800/40'
                "
              >
                <label
                  class="flex items-start gap-3 p-4"
                  [ngClass]="isReadOnly ? 'cursor-default' : 'cursor-pointer'"
                >
                  <input
                    type="checkbox"
                    [ngModel]="hasLine"
                    (ngModelChange)="onHasLineChange($event)"
                    [disabled]="isReadOnly"
                    class="mt-0.5 w-4 h-4 rounded text-amber-500 focus:ring-amber-200"
                  />
                  <div class="min-w-0">
                    <p
                      class="text-sm font-bold text-slate-700 dark:text-slate-200 flex items-center gap-2"
                    >
                      <span class="material-icons text-base text-emerald-500"
                        >chat</span
                      >
                      ผู้ใช้มีบัญชี LINE (City Parking)
                      <span
                        class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-slate-200/70 dark:bg-slate-700 text-slate-500 dark:text-slate-400"
                        >ไม่บังคับ</span
                      >
                    </p>
                    <p
                      class="text-xs text-slate-500 dark:text-slate-400 mt-0.5"
                    >
                      ติ๊กเมื่อต้องการผูกบัตรกับบัญชี LINE — ระบบจะยืนยันตัวตน
                      เติมชื่อ/เบอร์ และดึงทะเบียนจาก City Parking ให้
                    </p>
                  </div>
                </label>

                <div
                  *ngIf="hasLine"
                  class="px-4 pb-4 pt-4 space-y-4 border-t border-emerald-100 dark:border-emerald-900/40"
                >
                  <div
                    *ngIf="!isReadOnly && (isCreate || !payload.lineId)"
                    class="space-y-4"
                  >
                    <div class="flex flex-col md:flex-row gap-3">
                      <div
                        class="flex rounded-xl bg-slate-50 dark:bg-slate-800 p-1 border border-slate-100 dark:border-slate-700 h-[46px] shrink-0"
                      >
                        <button
                          type="button"
                          (click)="verifySearchType = 'phone'"
                          [disabled]="isReadOnly"
                          class="px-4 py-1.5 rounded-lg text-sm font-bold transition-all cursor-pointer"
                          [ngClass]="
                            verifySearchType === 'phone'
                              ? 'bg-amber-400 text-white shadow-md shadow-amber-200/50'
                              : 'text-slate-500 hover:text-slate-700'
                          "
                        >
                          เบอร์โทร
                        </button>
                        <button
                          type="button"
                          (click)="verifySearchType = 'lineid'"
                          [disabled]="isReadOnly"
                          class="px-4 py-1.5 rounded-lg text-sm font-bold transition-all cursor-pointer"
                          [ngClass]="
                            verifySearchType === 'lineid'
                              ? 'bg-amber-400 text-white shadow-md shadow-amber-200/50'
                              : 'text-slate-500 hover:text-slate-700'
                          "
                        >
                          Line UID
                        </button>
                      </div>
                      <div
                        data-field="line"
                        class="relative flex-1 flex items-center bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]"
                        [class.field-invalid]="isInvalid('line')"
                      >
                        <span
                          class="absolute left-3 material-icons text-slate-400 text-lg"
                          >search</span
                        >
                        <input
                          type="text"
                          [(ngModel)]="verifySearchText"
                          placeholder="ค้นหาผู้ใช้..."
                          [readonly]="isReadOnly"
                          class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium focus:outline-none"
                        />
                      </div>
                      <button
                        type="button"
                        (click)="verifyUser()"
                        [disabled]="isVerifying || isReadOnly"
                        class="h-[46px] px-5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold text-sm transition-colors disabled:opacity-50"
                      >
                        {{ isVerifying ? "กำลังตรวจสอบ..." : "ตรวจสอบ" }}
                      </button>
                    </div>
                    <p *ngIf="isInvalid('line')" class="field-error-text -mt-2">
                      <span class="material-icons text-sm">error</span>
                      กรุณากดตรวจสอบบัญชี LINE หรือเอาติ๊ก "มีบัญชี LINE" ออก
                    </p>
                    <div
                      *ngIf="userVerified"
                      class="p-3 rounded-xl bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-800 flex justify-between items-center gap-3"
                    >
                      <span
                        class="text-sm text-emerald-800 dark:text-emerald-300"
                        ><b>ยืนยันแล้ว:</b> {{ payload.name }} ({{
                          payload.uid
                        }})</span
                      >
                      <button
                        type="button"
                        (click)="clearVerifiedUser()"
                        class="text-xs font-bold text-rose-500 hover:text-rose-600"
                        *ngIf="!isReadOnly"
                      >
                        ยกเลิก
                      </button>
                    </div>
                    <div *ngIf="showCandidateList" class="space-y-2">
                      <button
                        *ngFor="let c of verifyCandidates"
                        type="button"
                        (click)="selectVerifiedCandidate(c)"
                        class="w-full text-left p-3 rounded-xl border border-slate-100 dark:border-slate-700 hover:border-amber-300 dark:hover:border-amber-500/50 bg-white dark:bg-slate-800 transition-colors"
                      >
                        <div
                          class="font-bold text-slate-800 dark:text-slate-100"
                        >
                          {{ c.fullName }}
                        </div>
                        <div class="text-xs text-slate-500 dark:text-slate-400">
                          {{ c.phone }} | {{ c.lineId }}
                        </div>
                      </button>
                    </div>
                  </div>

                  <div>
                    <label
                      class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2"
                      >Line UID</label
                    >
                    <div
                      class="relative flex items-center bg-slate-100 dark:bg-slate-800/80 rounded-xl border border-slate-100 dark:border-slate-700 h-[46px]"
                    >
                      <span
                        class="absolute left-3 material-icons text-slate-400"
                        >chat</span
                      >
                      <input
                        type="text"
                        [ngModel]="payload.lineId"
                        readonly
                        placeholder="กดตรวจสอบเพื่อดึง Line UID"
                        class="w-full pl-10 pr-16 py-2 bg-transparent border-none text-sm font-medium text-slate-500 focus:outline-none"
                      />
                      <button
                        *ngIf="payload.lineId && !isReadOnly"
                        type="button"
                        (click)="cancelLineId()"
                        class="absolute right-3 text-xs font-bold text-rose-500 hover:text-rose-600 hover:bg-rose-200/50 p-1 px-2 rounded-2xl transition-colors cursor-pointer"
                      >
                        ยกเลิก
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- เลขบัตร: สร้างใหม่ = ระบบจัดการ, แก้ไข/ดู = แสดง readonly -->
              <!-- <div
                *ngIf="isCreate"
                class="p-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50/80 dark:bg-slate-800/40 flex items-start gap-3"
              >
                <span class="material-icons text-amber-500 mt-0.5">info</span>
                <div>
                  <p
                    class="text-sm font-bold text-slate-700 dark:text-slate-200"
                  >
                    เลขบัตรจอดรถ
                  </p>
                  <p class="text-sm text-slate-500 dark:text-slate-400 mt-0.5">
                    ระบบจะสร้างเลขบัตรให้อัตโนมัติหลังบันทึก — ไม่ต้องระบุเอง
                  </p>
                </div>
              </div> -->

              <div
                *ngIf="!isCreate"
                class="grid grid-cols-1 md:grid-cols-2 gap-5"
              >
                <div>
                  <label
                    class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2"
                    >รหัสบัตร (card_code)</label
                  >
                  <div
                    class="relative flex items-center bg-slate-100 dark:bg-slate-800/80 rounded-xl border border-slate-100 dark:border-slate-700 h-[46px]"
                  >
                    <span class="absolute left-3 material-icons text-slate-400"
                      >pin</span
                    >
                    <input
                      type="text"
                      [ngModel]="payload.cardCode"
                      readonly
                      class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-mono font-bold text-slate-600 dark:text-slate-300 focus:outline-none"
                    />
                  </div>
                </div>
                <div>
                  <label
                    class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2"
                    >ชื่อผู้ถือบัตร (card_name)</label
                  >
                  <div
                    class="relative flex items-center bg-slate-100 dark:bg-slate-800/80 rounded-xl border border-slate-100 dark:border-slate-700 h-[46px]"
                  >
                    <span class="absolute left-3 material-icons text-slate-400"
                      >badge</span
                    >
                    <input
                      type="text"
                      [ngModel]="payload['cardName']"
                      readonly
                      class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-bold text-slate-600 dark:text-slate-300 focus:outline-none"
                    />
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div>
                  <label
                    class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2"
                    >ชื่อ-นามสกุล <span class="text-rose-500">*</span></label
                  >
                  <div
                    data-field="name"
                    class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]"
                    [class.field-invalid]="isInvalid('name')"
                  >
                    <span class="absolute left-3 material-icons text-slate-400"
                      >person</span
                    >
                    <input
                      type="text"
                      [(ngModel)]="payload.name"
                      [readonly]="isReadOnly"
                      placeholder="ชื่อ-นามสกุล"
                      class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium focus:outline-none"
                    />
                  </div>
                  <p *ngIf="isInvalid('name')" class="field-error-text">
                    <span class="material-icons text-sm">error</span>
                    กรุณากรอกชื่อ-นามสกุล
                  </p>
                </div>
                <div>
                  <label
                    class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2"
                    >เบอร์โทร</label
                  >
                  <div
                    class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]"
                  >
                    <span class="absolute left-3 material-icons text-slate-400"
                      >phone</span
                    >
                    <input
                      type="text"
                      [(ngModel)]="payload.phone"
                      [readonly]="isReadOnly"
                      placeholder="เบอร์โทรศัพท์"
                      class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium focus:outline-none"
                    />
                  </div>
                </div>
              </div>

              <div>
                <label
                  class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2"
                  >ที่อยู่</label
                >
                <div
                  class="relative flex items-start bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200"
                >
                  <span
                    class="absolute left-3 top-3 material-icons text-slate-400"
                    >home</span
                  >
                  <textarea
                    [(ngModel)]="payload.address"
                    rows="3"
                    [readonly]="isReadOnly"
                    placeholder="ที่อยู่"
                    class="w-full pl-10 pr-4 py-3 bg-transparent border-none text-sm font-medium focus:outline-none resize-none"
                  ></textarea>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Tab: การเข้า-ออก -->
          <div
            *ngIf="activeTab === 'accessInfo'"
            class="w-full space-y-5 animate-fade-in"
          >
            <div
              *ngIf="isQuotaCreate && requiresClientFirst"
              class="p-8 rounded-2xl border border-dashed border-amber-300 dark:border-amber-700 text-center text-amber-700 dark:text-amber-300"
            >
              <span class="material-icons text-4xl mb-2">store</span>
              <p class="font-bold">
                กรุณาเลือกร้านในขั้นตอน "ข้อมูลผู้ใช้" ก่อน
              </p>
            </div>

            <ng-container *ngIf="!requiresClientFirst">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div *ngIf="!isQuotaCreate" class="md:col-span-2">
                  <label
                    class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2"
                    >ประเภทสิทธิ์ <span class="text-rose-500">*</span></label
                  >
                  <div class="relative">
                    <div class="relative flex items-center">
                      <input
                        type="text"
                        data-field="cardType"
                        [class.field-invalid]="isInvalid('cardType')"
                        [(ngModel)]="searchCardTypeText"
                        [readonly]="isReadOnly"
                        placeholder="เลือกหรือพิมพ์เพื่อค้นหาประเภทสิทธิ์..."
                        (focus)="onInputFocus('cardType')"
                        (click)="
                          onInputFocus('cardType'); $event.stopPropagation()
                        "
                        (blur)="closeDropdowns()"
                        class="w-full h-[46px] pl-4 pr-10 bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-xl text-sm font-medium text-slate-700 dark:text-slate-200 focus:bg-white dark:focus:bg-slate-900 focus:ring-2 focus:ring-amber-200 outline-none transition-all placeholder:font-normal"
                      />
                      <span
                        class="material-icons text-slate-400 text-sm absolute right-4 transition-transform pointer-events-none cursor-pointer"
                        [class.rotate-180]="openDropdown === 'cardType'"
                        >expand_more</span
                      >
                    </div>
                    <div
                      *ngIf="openDropdown === 'cardType'"
                      (mousedown)="$event.preventDefault()"
                      class="absolute top-full left-0 right-0 mt-2 z-50 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-48 overflow-y-auto custom-scrollbar animate-fade-in-up"
                    >
                      <div
                        *ngIf="filteredCardTypes.length === 0"
                        class="px-4 py-3 text-sm text-slate-400 text-center font-bold"
                      >
                        ไม่พบข้อมูลที่ค้นหา
                      </div>
                      <div
                        *ngFor="let ct of filteredCardTypes"
                        (click)="selectCardType(ct)"
                        class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 dark:hover:text-amber-500 cursor-pointer transition-all text-slate-700 dark:text-slate-300"
                      >
                        {{ ct.name }}
                      </div>
                    </div>
                  </div>
                  <p *ngIf="isInvalid('cardType')" class="field-error-text">
                    <span class="material-icons text-sm">error</span>
                    กรุณาเลือกประเภทสิทธิ์จากรายการ
                  </p>
                </div>
                <div *ngIf="showQuotaCardTypePicker" class="md:col-span-2">
                  <label
                    class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2"
                    >ประเภทบัตร Platform
                    <span class="text-rose-500">*</span></label
                  >
                  <div class="relative">
                    <div class="relative flex items-center">
                      <input
                        type="text"
                        data-field="quotaType"
                        [class.field-invalid]="isInvalid('quotaType')"
                        [(ngModel)]="searchQuotaTypeText"
                        [readonly]="isReadOnly"
                        placeholder="เลือกหรือพิมพ์เพื่อค้นหาประเภทบัตร..."
                        (focus)="onInputFocus('quotaType')"
                        (click)="
                          onInputFocus('quotaType'); $event.stopPropagation()
                        "
                        (blur)="closeDropdowns()"
                        class="w-full h-[46px] pl-4 pr-10 bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-xl text-sm font-medium text-slate-700 dark:text-slate-200 focus:bg-white dark:focus:bg-slate-900 focus:ring-2 focus:ring-amber-200 outline-none transition-all placeholder:font-normal"
                      />
                      <span
                        class="material-icons text-slate-400 text-sm absolute right-4 transition-transform pointer-events-none cursor-pointer"
                        [class.rotate-180]="openDropdown === 'quotaType'"
                        >expand_more</span
                      >
                    </div>
                    <div
                      *ngIf="openDropdown === 'quotaType'"
                      (mousedown)="$event.preventDefault()"
                      class="absolute top-full left-0 right-0 mt-2 z-50 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-48 overflow-y-auto custom-scrollbar animate-fade-in-up"
                    >
                      <div
                        *ngIf="filteredPlatformCardTypes.length === 0"
                        class="px-4 py-3 text-sm text-slate-400 text-center font-bold"
                      >
                        ไม่พบข้อมูลที่ค้นหา
                      </div>
                      <div
                        *ngFor="let t of filteredPlatformCardTypes"
                        (click)="selectQuotaType(t)"
                        class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 dark:hover:text-amber-500 cursor-pointer transition-all text-slate-700 dark:text-slate-300"
                      >
                        {{ quotaTypeLabel(t) }}
                      </div>
                    </div>
                  </div>
                  <p *ngIf="isInvalid('quotaType')" class="field-error-text">
                    <span class="material-icons text-sm">error</span>
                    กรุณาเลือกประเภทบัตร Platform จากรายการ
                  </p>
                </div>
                <div
                  *ngIf="isQuotaCreate && quotaAccessLocked"
                  class="md:col-span-2"
                >
                  <label
                    class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2"
                    >ประเภทบัตร / Subscription (จากโควต้า)</label
                  >
                  <div
                    class="p-4 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 text-sm space-y-2"
                  >
                    <div>
                      <span class="text-slate-500 dark:text-slate-400"
                        >ประเภทบัตร</span
                      >
                      <div
                        class="font-bold text-slate-800 dark:text-slate-100 mt-0.5"
                      >
                        {{
                          quotaAccessCardTypeLabel ||
                            selectedPlatformCardType?.cardTypeName ||
                            "-"
                        }}
                      </div>
                    </div>
                    <div>
                      <span class="text-slate-500 dark:text-slate-400"
                        >Subscription</span
                      >
                      <div
                        class="font-bold text-slate-800 dark:text-slate-100 mt-0.5"
                      >
                        {{
                          quotaAccessSubscriptionLabel ||
                            selectedPlatformCardType?.subscriptionName ||
                            "ID " + access.subscriptionId
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                *ngIf="isQuotaContext"
                class="p-4 rounded-xl border border-amber-200/60 dark:border-amber-500/30 bg-amber-50/40 dark:bg-amber-500/10 flex items-start gap-3"
              >
                <span class="material-icons text-amber-500">info</span>
                <p class="text-sm text-amber-800 dark:text-amber-300">
                  Subscription และ Rate / Gate Group ถูกกำหนดจากโควต้าหรือ
                  whitelist (path 51) แล้ว — ไม่ต้องเลือกซ้ำ
                </p>
              </div>
              <div
                *ngIf="!isQuotaContext"
                class="p-4 rounded-xl border border-amber-200/60 dark:border-amber-500/30 bg-amber-50/40 dark:bg-amber-500/10 flex items-start gap-3"
              >
                <span class="material-icons text-amber-500">info</span>
                <p class="text-sm text-amber-800 dark:text-amber-300">
                  เลือก Subscription — ระบบจะดึง Rate และ Gate Group
                  ให้อัตโนมัติ
                </p>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div>
                  <label
                    class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2"
                    >Site</label
                  >
                  <div
                    class="h-[46px] px-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 flex items-center text-sm font-bold text-slate-700 dark:text-slate-200"
                  >
                    Site ID: {{ siteId }}
                  </div>
                </div>
                <div>
                  <label
                    class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2"
                    >สถานะบัตร</label
                  >
                  <div class="relative">
                    <div class="relative flex items-center">
                      <input
                        type="text"
                        [(ngModel)]="searchCardModeText"
                        readonly
                        placeholder="สถานะบัตร..."
                        (focus)="!isReadOnly && onInputFocus('cardMode')"
                        (click)="
                          !isReadOnly && onInputFocus('cardMode');
                          $event.stopPropagation()
                        "
                        (blur)="closeDropdowns()"
                        class="w-full h-[46px] pl-4 pr-10 bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-xl text-sm font-medium text-slate-700 dark:text-slate-200 focus:bg-white dark:focus:bg-slate-900 focus:ring-2 focus:ring-amber-200 outline-none transition-all placeholder:font-normal"
                        [ngClass]="!isReadOnly ? 'cursor-pointer' : ''"
                      />
                      <span
                        class="material-icons text-slate-400 text-sm absolute right-4 transition-transform pointer-events-none cursor-pointer"
                        [class.rotate-180]="openDropdown === 'cardMode'"
                        >expand_more</span
                      >
                    </div>
                    <div
                      *ngIf="openDropdown === 'cardMode'"
                      (mousedown)="$event.preventDefault()"
                      class="absolute top-full left-0 right-0 mt-2 z-50 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-48 overflow-y-auto custom-scrollbar animate-fade-in-up"
                    >
                      <div
                        *ngFor="let o of cardModeOptions"
                        (click)="selectCardMode(o.value, o.label)"
                        class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 dark:hover:text-amber-500 cursor-pointer transition-all text-slate-700 dark:text-slate-300"
                      >
                        {{ o.label }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="!isQuotaContext">
                <label
                  class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2"
                  >Subscription <span class="text-rose-500">*</span></label
                >
                <div class="relative">
                  <div class="relative flex items-center">
                    <input
                      type="text"
                      data-field="subscription"
                      [class.field-invalid]="isInvalid('subscription')"
                      [(ngModel)]="searchSubscriptionText"
                      [readonly]="isReadOnly"
                      placeholder="เลือกหรือพิมพ์เพื่อค้นหา Subscription..."
                      (focus)="onInputFocus('subscription')"
                      (click)="
                        onInputFocus('subscription'); $event.stopPropagation()
                      "
                      (blur)="closeDropdowns()"
                      class="w-full h-[46px] pl-4 pr-10 bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 rounded-xl text-sm font-medium text-slate-700 dark:text-slate-200 focus:bg-white dark:focus:bg-slate-900 focus:ring-2 focus:ring-amber-200 outline-none transition-all placeholder:font-normal"
                    />
                    <span
                      class="material-icons text-slate-400 text-sm absolute right-4 transition-transform pointer-events-none cursor-pointer"
                      [class.rotate-180]="openDropdown === 'subscription'"
                      >expand_more</span
                    >
                  </div>
                  <div
                    *ngIf="openDropdown === 'subscription'"
                    (mousedown)="$event.preventDefault()"
                    class="absolute top-full left-0 right-0 mt-2 z-50 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 max-h-48 overflow-y-auto custom-scrollbar animate-fade-in-up"
                  >
                    <div
                      *ngIf="filteredSubscriptions.length === 0"
                      class="px-4 py-3 text-sm text-slate-400 text-center font-bold"
                    >
                      ไม่พบข้อมูลที่ค้นหา
                    </div>
                    <div
                      *ngFor="let s of filteredSubscriptions"
                      (click)="selectSubscription(s)"
                      class="px-4 py-2.5 text-sm font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 dark:hover:text-amber-500 cursor-pointer transition-all text-slate-700 dark:text-slate-300"
                    >
                      {{ s.name }}
                    </div>
                  </div>
                </div>
                <p *ngIf="isInvalid('subscription')" class="field-error-text">
                  <span class="material-icons text-sm">error</span>
                  {{
                    access.subscriptionId
                      ? "Subscription นี้ไม่มี Rate / Gate Group — กรุณาเลือกใหม่"
                      : "กรุณาเลือก Subscription จากรายการ"
                  }}
                </p>
              </div>

              <div
                *ngIf="isQuotaContext && access.subscriptionId"
                class="p-4 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 text-sm"
              >
                <span class="text-slate-500 dark:text-slate-400"
                  >Subscription (จากโควต้า)</span
                >
                <div class="font-bold text-slate-800 dark:text-slate-100 mt-1">
                  {{
                    quotaAccessSubscriptionLabel ||
                      selectedPlatformCardType?.subscriptionName ||
                      "ID " + access.subscriptionId
                  }}
                </div>
              </div>

              <div
                class="grid grid-cols-1 md:grid-cols-2 gap-4"
                *ngIf="access.subscriptionId"
              >
                <div
                  class="p-4 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 text-sm"
                >
                  <span class="text-slate-500 dark:text-slate-400">Rate</span>
                  <div
                    class="font-bold text-slate-800 dark:text-slate-100 mt-1"
                  >
                    {{ access.rateName || "-" }}
                  </div>
                  <div
                    class="text-xs text-slate-400 dark:text-slate-500 mt-0.5"
                    *ngIf="access.rateId"
                  >
                    ID: {{ access.rateId }}
                  </div>
                </div>
                <div
                  class="p-4 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 text-sm"
                >
                  <span class="text-slate-500 dark:text-slate-400"
                    >Gate Group</span
                  >
                  <div
                    class="font-bold text-slate-800 dark:text-slate-100 mt-1"
                  >
                    {{ access.gateGroupName || "-" }}
                  </div>
                  <div
                    class="text-xs text-slate-400 dark:text-slate-500 mt-0.5"
                    *ngIf="access.gateGroupId"
                  >
                    ID: {{ access.gateGroupId }}
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div>
                  <label
                    class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2"
                    >วันเริ่มสิทธิ์ (00:00)
                    <span class="text-rose-500">*</span></label
                  >
                  <div class="relative">
                    <span
                      class="absolute left-3 top-1/2 -translate-y-1/2 material-icons-outlined text-slate-400 text-[18px] pointer-events-none z-10"
                      >event</span
                    >
                    <input
                      type="text"
                      data-field="issueDate"
                      [class.field-invalid]="isInvalid('issueDate')"
                      [matDatepicker]="issueDatePicker"
                      [(ngModel)]="access.issueDate"
                      [disabled]="isReadOnly"
                      placeholder="dd/mm/yyyy"
                      readonly
                      (click)="!isReadOnly && issueDatePicker.open()"
                      class="w-full h-[46px] pl-10 pr-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200"
                      [ngClass]="!isReadOnly ? 'cursor-pointer' : ''"
                    />
                    <mat-datepicker
                      #issueDatePicker
                      panelClass="modern-yellow-datepicker"
                    ></mat-datepicker>
                  </div>
                  <p *ngIf="isInvalid('issueDate')" class="field-error-text">
                    <span class="material-icons text-sm">error</span>
                    กรุณาเลือกวันเริ่มสิทธิ์
                  </p>
                </div>
                <div>
                  <label
                    class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2"
                    >วันหมดอายุ (23:59)
                    <span class="text-rose-500">*</span></label
                  >
                  <div class="relative">
                    <span
                      class="absolute left-3 top-1/2 -translate-y-1/2 material-icons-outlined text-slate-400 text-[18px] pointer-events-none z-10"
                      >event</span
                    >
                    <input
                      type="text"
                      data-field="expireDate"
                      [class.field-invalid]="isInvalid('expireDate')"
                      [matDatepicker]="expireDatePicker"
                      [(ngModel)]="access.expireDate"
                      [disabled]="isReadOnly"
                      [min]="access.issueDate"
                      placeholder="dd/mm/yyyy"
                      readonly
                      (click)="!isReadOnly && expireDatePicker.open()"
                      class="w-full h-[46px] pl-10 pr-4 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-200"
                      [ngClass]="!isReadOnly ? 'cursor-pointer' : ''"
                    />
                    <mat-datepicker
                      #expireDatePicker
                      panelClass="modern-yellow-datepicker"
                    ></mat-datepicker>
                  </div>
                  <p *ngIf="isInvalid('expireDate')" class="field-error-text">
                    <span class="material-icons text-sm">error</span>
                    กรุณาเลือกวันหมดอายุ
                  </p>
                </div>
              </div>

              <div
                *ngIf="mode === 'edit' && !isQuotaContext"
                class="p-4 rounded-xl border border-sky-200 dark:border-sky-800 bg-sky-50/50 dark:bg-sky-900/20"
              >
                <label class="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    [(ngModel)]="access.isRenewal"
                    [disabled]="isReadOnly"
                    class="rounded text-amber-500 focus:ring-amber-200"
                  />
                  <span class="text-sm font-bold text-sky-800 dark:text-sky-300"
                    >ต่ออายุสมาชิก (บัตรต้องหมดอายุแล้ว)</span
                  >
                </label>
              </div>
            </ng-container>
          </div>

          <!-- Tab: ทะเบียนรถ -->
          <div
            *ngIf="activeTab === 'vehicles'"
            class="animate-fade-in pb-4 space-y-4"
          >
            <div
              *ngIf="isQuotaCreate && requiresClientFirst"
              class="p-8 rounded-2xl border border-dashed border-amber-300 dark:border-amber-700 text-center text-amber-700 dark:text-amber-300"
            >
              <span class="material-icons text-4xl mb-2">store</span>
              <p class="font-bold">
                กรุณาเลือกร้านในขั้นตอน "ข้อมูลผู้ใช้" ก่อน
              </p>
            </div>

            <ng-container *ngIf="!requiresClientFirst">
              <div class="flex flex-wrap gap-3" *ngIf="!isReadOnly">
                <button
                  type="button"
                  data-field="vehicles"
                  (click)="addVehicleLine()"
                  [disabled]="getActiveVehicles().length >= 1"
                  class="px-4 py-2 rounded-xl bg-slate-100 dark:bg-slate-800 font-bold text-sm text-slate-600 dark:text-slate-300 hover:bg-amber-200/50 hover:text-amber-700 dark:hover:bg-slate-700 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  + เพิ่มทะเบียน
                </button>
                <button
                  *ngIf="hasLine"
                  type="button"
                  (click)="openCityVehiclePicker()"
                  [disabled]="!userVerified || getActiveVehicles().length >= 1"
                  class="px-4 py-2 rounded-xl bg-amber-100 dark:bg-amber-500/20 text-amber-700 dark:text-amber-400 font-bold text-sm hover:bg-amber-200 dark:hover:bg-amber-500/30 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  เลือกจาก City Parking
                </button>
              </div>

              <p *ngIf="isInvalid('vehicles')" class="field-error-text">
                <span class="material-icons text-sm">error</span>
                {{
                  getActiveVehicles().length === 0
                    ? 'กรุณากด "+ เพิ่มทะเบียน" เพื่อเพิ่มทะเบียนรถ 1 คัน'
                    : "ต้องเหลือทะเบียนรถเพียง 1 คัน — กรุณาลบทะเบียนส่วนเกิน"
                }}
              </p>

              <div
                class="overflow-x-auto rounded-2xl border border-slate-100 dark:border-slate-800 min-h-[300px]"
                [class.field-invalid]="isInvalid('vehicles')"
              >
                <table class="w-full text-sm">
                  <thead
                    class="bg-slate-50 dark:bg-slate-800/80 text-slate-500 dark:text-slate-400"
                  >
                    <tr>
                      <th class="py-3 px-4 text-left font-bold">
                        ทะเบียน <span class="text-rose-500">*</span>
                      </th>
                      <th class="py-3 px-4 text-left font-bold">
                        จังหวัด <span class="text-rose-500">*</span>
                      </th>
                      <th class="py-3 px-4 text-center font-bold">Active</th>
                      <th
                        class="py-3 px-4 text-center font-bold"
                        *ngIf="!isReadOnly"
                      >
                        ลบ
                      </th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
                    <tr
                      *ngFor="let v of payload.vehicles; let i = index"
                      [hidden]="v.isDeleted"
                      class="hover:bg-slate-50/50 dark:hover:bg-slate-800/30"
                    >
                      <td class="p-2">
                        <input
                          [attr.data-field]="'plate-' + i"
                          [class.field-invalid]="isVehiclePlateInvalid(v)"
                          placeholder="เลขทะเบียน"
                          [(ngModel)]="v.licensePlate"
                          [readonly]="isReadOnly"
                          class="w-full px-3 py-2 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm focus:outline-none focus:ring-2 focus:ring-amber-200"
                        />
                      </td>
                      <td class="p-2 relative z-[50]">
                        <div class="relative flex items-center z-[10]">
                          <input
                            type="text"
                            [attr.data-field]="'province-' + i"
                            [class.field-invalid]="isVehicleProvinceInvalid(v)"
                            [ngModel]="
                              openVehicleProvinceIndex === i
                                ? searchVehicleProvinceText
                                : v.province
                            "
                            (ngModelChange)="
                              openVehicleProvinceIndex === i
                                ? (searchVehicleProvinceText = $event)
                                : null
                            "
                            [readonly]="isReadOnly"
                            placeholder="พิมพ์ชื่อจังหวัด..."
                            (focus)="focusVehicleProvince(i, v)"
                            (click)="
                              focusVehicleProvince(i, v);
                              $event.stopPropagation()
                            "
                            (blur)="closeDropdowns()"
                            class="w-full px-3 py-2 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm focus:outline-none focus:ring-2 focus:ring-amber-200"
                          />
                          <span
                            class="material-icons text-slate-400 text-sm absolute right-2 transition-transform pointer-events-none cursor-pointer"
                            [class.rotate-180]="
                              openDropdown === 'vehicleProvince' &&
                              openVehicleProvinceIndex === i
                            "
                            >expand_more</span
                          >
                        </div>
                        <div
                          *ngIf="
                            openDropdown === 'vehicleProvince' &&
                            openVehicleProvinceIndex === i
                          "
                          (mousedown)="$event.preventDefault()"
                          class="absolute top-full left-0 right-0 mt-1 z-[99] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1.5 max-h-48 overflow-y-auto custom-scrollbar min-w-[150px] animate-fade-in-up"
                        >
                          <div
                            *ngIf="filteredProvinces.length === 0"
                            class="px-3 py-2 text-xs text-slate-400 text-center font-bold"
                          >
                            ไม่พบข้อมูล
                          </div>
                          <div
                            *ngFor="let p of filteredProvinces"
                            (click)="selectVehicleProvince(v, p)"
                            class="px-3 py-2 text-xs font-bold hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 dark:hover:text-amber-500 cursor-pointer transition-all text-slate-700 dark:text-slate-300"
                          >
                            {{ p.name }}
                          </div>
                        </div>
                      </td>
                      <td class="p-2 text-center">
                        <input
                          type="checkbox"
                          [(ngModel)]="v.active"
                          [disabled]="isReadOnly"
                          class="rounded text-amber-500 focus:ring-amber-200"
                        />
                      </td>
                      <td class="p-2 text-center" *ngIf="!isReadOnly">
                        <button
                          type="button"
                          (click)="removeVehicle(i)"
                          class="w-8 h-8 rounded-lg text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/20 transition-colors"
                        >
                          <span class="material-icons-outlined text-lg"
                            >delete</span
                          >
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                *ngIf="isVehiclePickerOpen"
                class="p-4 rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/40 space-y-3"
              >
                <div class="flex justify-between items-center">
                  <h4
                    class="font-bold text-sm text-slate-800 dark:text-slate-100"
                  >
                    เลือกทะเบียนจาก City Parking
                  </h4>
                  <button
                    type="button"
                    (click)="isVehiclePickerOpen = false"
                    class="text-slate-400 hover:text-slate-600"
                  >
                    <span class="material-icons-outlined">close</span>
                  </button>
                </div>
                <div
                  *ngIf="isLoadingCityVehicles"
                  class="text-sm text-slate-500"
                >
                  กำลังโหลด...
                </div>
                <button
                  *ngFor="let item of cityVehiclePicker"
                  type="button"
                  (click)="addVehicleFromPicker(item)"
                  class="w-full text-left p-3 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-500/50 transition-colors"
                >
                  <div class="font-bold text-slate-800 dark:text-slate-100">
                    {{ item.plateNumber }}
                  </div>
                  <div class="text-xs text-slate-500 dark:text-slate-400">
                    {{ item.provinceName }}
                  </div>
                </button>
              </div>
            </ng-container>
          </div>

          <!-- Step: ตรวจสอบ & บันทึก -->
          <div
            *ngIf="activeTab === 'review'"
            class="w-full space-y-5 animate-fade-in"
          >
            <div
              class="p-4 rounded-xl border border-sky-200 dark:border-sky-800 bg-sky-50/70 dark:bg-sky-950/20 flex items-start gap-3"
            >
              <span class="material-icons text-sky-500">fact_check</span>
              <p class="text-sm text-sky-900 dark:text-sky-100">
                ตรวจสอบข้อมูลให้ถูกต้องก่อนกด
                <b>{{ isQuotaCreate ? "ออกบัตร" : "สร้างบัตร" }}</b> — กด
                "แก้ไข" ที่หัวข้อเพื่อย้อนกลับไปแก้ได้
              </p>
            </div>

            <div
              class="rounded-2xl border border-slate-100 dark:border-slate-800 overflow-hidden"
            >
              <div
                class="px-4 py-3 bg-slate-50/80 dark:bg-slate-800/40 flex items-center justify-between border-b border-slate-100 dark:border-slate-800"
              >
                <h4
                  class="text-sm font-bold text-slate-700 dark:text-slate-200 flex items-center gap-2"
                >
                  <span class="material-icons text-base text-amber-500"
                    >person</span
                  >
                  ข้อมูลผู้ใช้
                </h4>
                <button
                  type="button"
                  (click)="goWizardStep(0)"
                  class="text-xs font-bold text-amber-600 hover:text-amber-700"
                >
                  แก้ไข
                </button>
              </div>
              <dl
                class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3 p-4 text-sm"
              >
                <div>
                  <dt class="text-xs font-bold text-slate-400">
                    ร้าน / Client
                  </dt>
                  <dd class="font-bold text-slate-800 dark:text-slate-100">
                    {{ clientSearchText || "-" }}
                  </dd>
                </div>
                <div>
                  <dt class="text-xs font-bold text-slate-400">ชื่อ-นามสกุล</dt>
                  <dd class="font-bold text-slate-800 dark:text-slate-100">
                    {{ payload.name || "-" }}
                  </dd>
                </div>
                <div>
                  <dt class="text-xs font-bold text-slate-400">เบอร์โทร</dt>
                  <dd class="font-bold text-slate-800 dark:text-slate-100">
                    {{ payload.phone || "-" }}
                  </dd>
                </div>
                <div>
                  <dt class="text-xs font-bold text-slate-400">บัญชี LINE</dt>
                  <dd
                    class="font-bold"
                    [ngClass]="
                      hasLine
                        ? 'text-emerald-600 dark:text-emerald-400'
                        : 'text-slate-500 dark:text-slate-400'
                    "
                  >
                    {{
                      hasLine
                        ? "ผูกแล้ว · " + (payload.uid || "-")
                        : "ไม่มี / ไม่ผูก LINE"
                    }}
                  </dd>
                </div>
                <div class="md:col-span-2">
                  <dt class="text-xs font-bold text-slate-400">ที่อยู่</dt>
                  <dd
                    class="font-medium text-slate-700 dark:text-slate-200 whitespace-pre-line"
                  >
                    {{ payload.address || "-" }}
                  </dd>
                </div>
              </dl>
            </div>

            <div
              class="rounded-2xl border border-slate-100 dark:border-slate-800 overflow-hidden"
            >
              <div
                class="px-4 py-3 bg-slate-50/80 dark:bg-slate-800/40 flex items-center justify-between border-b border-slate-100 dark:border-slate-800"
              >
                <h4
                  class="text-sm font-bold text-slate-700 dark:text-slate-200 flex items-center gap-2"
                >
                  <span class="material-icons text-base text-amber-500"
                    >badge</span
                  >
                  ข้อมูลบัตร
                </h4>
                <button
                  type="button"
                  (click)="goWizardStep(1)"
                  class="text-xs font-bold text-amber-600 hover:text-amber-700"
                >
                  แก้ไข
                </button>
              </div>
              <dl
                class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3 p-4 text-sm"
              >
                <div>
                  <dt class="text-xs font-bold text-slate-400">
                    {{ isQuotaCreate ? "ประเภทบัตร Platform" : "ประเภทสิทธิ์" }}
                  </dt>
                  <dd class="font-bold text-slate-800 dark:text-slate-100">
                    {{
                      isQuotaCreate
                        ? quotaAccessCardTypeLabel ||
                          selectedPlatformCardType?.cardTypeName ||
                          searchQuotaTypeText ||
                          "-"
                        : searchCardTypeText || "-"
                    }}
                  </dd>
                </div>
                <div>
                  <dt class="text-xs font-bold text-slate-400">Subscription</dt>
                  <dd class="font-bold text-slate-800 dark:text-slate-100">
                    {{
                      isQuotaContext
                        ? quotaAccessSubscriptionLabel ||
                          selectedPlatformCardType?.subscriptionName ||
                          "-"
                        : searchSubscriptionText || "-"
                    }}
                  </dd>
                </div>
                <div>
                  <dt class="text-xs font-bold text-slate-400">
                    Rate / Gate Group
                  </dt>
                  <dd class="font-bold text-slate-800 dark:text-slate-100">
                    {{ access.rateName || "-" }} /
                    {{ access.gateGroupName || "-" }}
                  </dd>
                </div>
                <div>
                  <dt class="text-xs font-bold text-slate-400">สถานะบัตร</dt>
                  <dd class="font-bold text-slate-800 dark:text-slate-100">
                    {{ searchCardModeText || "-" }}
                  </dd>
                </div>
                <div class="md:col-span-2">
                  <dt class="text-xs font-bold text-slate-400">
                    ระยะเวลาสิทธิ์
                  </dt>
                  <dd
                    class="font-bold text-slate-800 dark:text-slate-100 tabular-nums"
                  >
                    {{ access.issueDate | date: "dd/MM/yyyy" : "" : "en-GB" }} —
                    {{ access.expireDate | date: "dd/MM/yyyy" : "" : "en-GB" }}
                  </dd>
                </div>
              </dl>
            </div>

            <div
              class="rounded-2xl border border-slate-100 dark:border-slate-800 overflow-hidden"
            >
              <div
                class="px-4 py-3 bg-slate-50/80 dark:bg-slate-800/40 flex items-center justify-between border-b border-slate-100 dark:border-slate-800"
              >
                <h4
                  class="text-sm font-bold text-slate-700 dark:text-slate-200 flex items-center gap-2"
                >
                  <span class="material-icons text-base text-amber-500"
                    >directions_car</span
                  >
                  ทะเบียนรถ
                </h4>
                <button
                  type="button"
                  (click)="goWizardStep(2)"
                  class="text-xs font-bold text-amber-600 hover:text-amber-700"
                >
                  แก้ไข
                </button>
              </div>
              <div
                class="p-4 text-sm font-bold text-slate-800 dark:text-slate-100"
              >
                {{ selectedVehicleSummary }}
              </div>
            </div>

            <div
              *ngIf="isQuotaCreate && activeClientQuota"
              class="p-4 rounded-xl border text-sm font-bold flex items-center gap-2"
              [ngClass]="
                activeClientQuota.quotaRemaining > 0
                  ? 'border-emerald-200 bg-emerald-50/60 text-emerald-700 dark:border-emerald-800 dark:bg-emerald-900/20 dark:text-emerald-400'
                  : 'border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-800 dark:bg-rose-900/20 dark:text-rose-400'
              "
            >
              <span class="material-icons text-base"
                >account_balance_wallet</span
              >
              จะหักโควต้า 1 ใบ — คงเหลือหลังออกบัตร
              {{ activeClientQuota.quotaRemaining - 1 }} ใบ
            </div>
          </div>

          <!-- Tab: ต่ออายุสมาชิก -->
          <div *ngIf="activeTab === 'renewals'" class="animate-fade-in">
            <p class="text-xs text-slate-500 dark:text-slate-400 mb-4">
              ประวัติการต่ออายุสมาชิก
            </p>
            <div
              class="overflow-x-auto rounded-2xl border border-slate-100 dark:border-slate-800"
            >
              <table class="w-full text-sm">
                <thead
                  class="bg-slate-50 dark:bg-slate-800/80 text-slate-500 dark:text-slate-400"
                >
                  <tr>
                    <th class="py-3 px-3 font-bold">ID</th>
                    <th class="py-3 px-3 font-bold">เริ่ม</th>
                    <th class="py-3 px-3 font-bold">สิ้นสุด</th>
                    <th class="py-3 px-3 font-bold">Finance</th>
                    <th class="py-3 px-3 font-bold">ยอด</th>
                    <th class="py-3 px-3 font-bold">สร้างเมื่อ</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
                  <tr
                    *ngFor="let r of renewals"
                    class="hover:bg-slate-50/50 dark:hover:bg-slate-800/30"
                  >
                    <td class="p-3 font-mono">{{ r.id }}</td>
                    <td class="p-3">
                      {{ r.startDate | date: "dd/MM/yyyy" : "" : "en-GB" }}
                    </td>
                    <td class="p-3">
                      {{ r.endDate | date: "dd/MM/yyyy" : "" : "en-GB" }}
                    </td>
                    <td class="p-3">{{ r.financeId ?? "-" }}</td>
                    <td class="p-3">{{ r.total ?? "-" }}</td>
                    <td class="p-3">
                      {{
                        r.createDate | date: "dd/MM/yyyy HH:mm" : "" : "en-GB"
                      }}
                    </td>
                  </tr>
                  <tr *ngIf="renewals.length === 0">
                    <td colspan="6" class="p-10 text-center text-slate-400">
                      ยังไม่มีประวัติต่ออายุ
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Tab: Taiwan Sync -->
          <div
            *ngIf="activeTab === 'taiwanSync'"
            class="animate-fade-in space-y-5"
          >
            <div class="flex flex-wrap items-start justify-between gap-3">
              <div>
                <p class="text-sm font-bold text-slate-700 dark:text-slate-200">
                  ซิงก์บัตรไประบบใต้หวัน
                </p>
                <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                  สถานะบน <span class="font-mono">ระบบบัตร</span> · ประวัติจาก
                  <span class="font-mono">การ Sync ข้อมูล</span>
                </p>
              </div>
              <div class="flex items-center gap-2">
                <button
                  type="button"
                  (click)="loadTaiwanSync()"
                  [disabled]="taiwanSyncLoading || taiwanResyncing"
                  class="px-3 h-10 rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-600 text-xs font-bold cursor-pointer disabled:opacity-50 inline-flex items-center gap-1"
                >
                  <span class="material-icons text-[16px]">refresh</span> รีเฟรช
                </button>
                <button
                  type="button"
                  (click)="resyncTaiwan()"
                  [disabled]="
                    !taiwanSyncStatus?.canResync ||
                    taiwanResyncing ||
                    taiwanSyncLoading
                  "
                  class="px-4 h-10 rounded-xl bg-amber-400 hover:bg-amber-500 disabled:opacity-50 text-slate-900 text-xs font-black cursor-pointer border-none inline-flex items-center gap-1.5"
                >
                  <span class="material-icons text-[16px]">send</span>
                  {{ taiwanSendButtonLabel }}
                </button>
              </div>
            </div>

            <div
              *ngIf="taiwanSyncLoading && !taiwanSyncStatus"
              class="py-16 flex justify-center"
            >
              <div
                class="w-9 h-9 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"
              ></div>
            </div>

            <ng-container *ngIf="taiwanSyncStatus as st">
              <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
                <div
                  class="rounded-2xl border border-slate-100 dark:border-slate-800 bg-slate-50/80 dark:bg-slate-800/40 p-4"
                >
                  <p
                    class="text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-2"
                  >
                    สถานะล่าสุด
                  </p>
                  <span
                    class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold"
                    [ngClass]="taiwanSyncStatusClass(st.taiwanSyncStatus)"
                  >
                    {{ taiwanSyncStatusLabel(st.taiwanSyncStatus) }}
                  </span>
                  <p
                    *ngIf="st.taiwanLastSyncAt"
                    class="text-[11px] text-slate-500 mt-2 tabular-nums"
                  >
                    {{
                      st.taiwanLastSyncAt
                        | date: "dd/MM/yyyy HH:mm" : "" : "en-GB"
                    }}
                  </p>
                </div>
                <div
                  class="rounded-2xl border border-slate-100 dark:border-slate-800 bg-slate-50/80 dark:bg-slate-800/40 p-4"
                >
                  <p
                    class="text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-2"
                  >
                    Site ID
                  </p>
                  <p
                    class="text-sm font-bold text-slate-700 dark:text-slate-200"
                  >
                    {{ st.taiwanSite ? "ใช่" : "ไม่ใช่" }}
                    <span
                      *ngIf="st.siteName"
                      class="font-medium text-slate-500"
                    >
                      · {{ st.siteName }}</span
                    >
                  </p>
                  <p class="text-[11px] text-slate-500 mt-1">
                    URL: {{ st.hasTaiwanUrl ? "มี" : "ไม่มี" }}
                  </p>
                </div>
                <div
                  class="rounded-2xl border border-slate-100 dark:border-slate-800 bg-slate-50/80 dark:bg-slate-800/40 p-4"
                >
                  <p
                    class="text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-2"
                  >
                    Local ID / Card No
                  </p>
                  <p
                    class="text-sm font-mono font-bold text-slate-700 dark:text-slate-200"
                  >
                    {{ st.allocatedCardNo || st.taiwanId || "—" }}
                  </p>
                  <p class="text-[11px] text-slate-500 mt-1">
                    identify: {{ st.identify || "general" }}
                  </p>
                </div>
                <div
                  class="rounded-2xl border border-slate-100 dark:border-slate-800 bg-slate-50/80 dark:bg-slate-800/40 p-4"
                >
                  <p
                    class="text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-2"
                  >
                    Error ล่าสุด
                  </p>
                  <p
                    class="text-xs text-rose-600 dark:text-rose-400 leading-snug break-words"
                  >
                    {{ st.taiwanLastSyncError || "—" }}
                  </p>
                </div>
              </div>

              <div
                *ngIf="!st.taiwanSite"
                class="rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 px-4 py-3 text-xs text-slate-500"
              >
                ไซต์นี้ไม่ได้เปิด <span class="font-mono">taiwan_site</span> —
                ไม่ต้อง sync ไป Taiwan
              </div>
              <div
                *ngIf="taiwanCannotSendReason && st.taiwanSite"
                class="rounded-xl border border-amber-200 dark:border-amber-900/40 bg-amber-50/80 dark:bg-amber-900/20 px-4 py-3 text-xs text-amber-800 dark:text-amber-300"
              >
                {{ taiwanCannotSendReason }}
              </div>
              <div
                *ngIf="st.canResync && isFirstTaiwanSend"
                class="rounded-xl border border-sky-200 dark:border-sky-900/40 bg-sky-50/80 dark:bg-sky-900/20 px-4 py-3 text-xs text-sky-800 dark:text-sky-300"
              >
                ยังไม่เคยส่งบัตรนี้ไป Taiwan — กด
                <span class="font-bold">ส่งไป Taiwan</span>
                เพื่อส่งครั้งแรกได้เลย (ระบบจะออกเลข
                <span class="font-mono">T########</span> และเขียน log ให้)
              </div>
            </ng-container>

            <div>
              <div class="flex items-center justify-between mb-3">
                <h4
                  class="text-sm font-black text-slate-700 dark:text-slate-200"
                >
                  ประวัติการส่ง
                </h4>
                <span class="text-[11px] font-bold text-slate-400"
                  >{{ taiwanSyncLogsTotal }} รายการ</span
                >
              </div>
              <div
                class="overflow-x-auto rounded-2xl border border-slate-100 dark:border-slate-800 relative"
              >
                <div
                  *ngIf="taiwanSyncLoading"
                  class="absolute inset-0 z-10 bg-white/50 dark:bg-slate-900/50 flex items-center justify-center"
                >
                  <div
                    class="w-7 h-7 border-3 border-amber-400 border-t-transparent rounded-full animate-spin"
                  ></div>
                </div>
                <table class="w-full text-sm">
                  <thead
                    class="bg-slate-50 dark:bg-slate-800/80 text-[11px] font-bold text-slate-400 uppercase tracking-wider"
                  >
                    <tr>
                      <th class="px-3 py-3 text-left">เวลา</th>
                      <th class="px-3 py-3 text-left">Action</th>
                      <th class="px-3 py-3 text-left">Trigger</th>
                      <th class="px-3 py-3 text-left">Status</th>
                      <th class="px-3 py-3 text-center">Attempt</th>
                      <th class="px-3 py-3 text-left">โดย</th>
                      <th class="px-3 py-3 text-left">Payload</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
                    <ng-container *ngFor="let log of taiwanSyncLogs">
                      <tr
                        class="hover:bg-slate-50/50 dark:hover:bg-slate-800/30"
                      >
                        <td
                          class="px-3 py-2.5 text-xs tabular-nums whitespace-nowrap text-slate-600 dark:text-slate-300"
                        >
                          {{
                            log.createDate
                              | date: "dd/MM/yy HH:mm" : "" : "en-GB"
                          }}
                        </td>
                        <td
                          class="px-3 py-2.5 text-xs font-bold text-slate-700 dark:text-slate-200"
                        >
                          {{ log.syncAction || "—" }}
                        </td>
                        <td class="px-3 py-2.5 text-xs text-slate-600">
                          {{ log.triggerType || "—" }}
                        </td>
                        <td class="px-3 py-2.5">
                          <span
                            class="inline-flex px-2 py-0.5 rounded-full text-[11px] font-bold"
                            [ngClass]="taiwanSyncStatusClass(log.status)"
                          >
                            {{ log.status || "—" }}
                          </span>
                        </td>
                        <td
                          class="px-3 py-2.5 text-center text-xs tabular-nums"
                        >
                          {{ log.attemptNo ?? "—" }}
                        </td>
                        <td class="px-3 py-2.5 text-xs text-slate-600">
                          {{
                            log.triggeredByLogin ||
                              (log.triggerType === "auto" ? "auto" : "—")
                          }}
                        </td>
                        <td class="px-3 py-2.5">
                          <button
                            type="button"
                            (click)="toggleTaiwanLogPayload(log.id)"
                            class="text-[11px] font-bold text-amber-600 hover:text-amber-700 cursor-pointer border-none bg-transparent px-0"
                          >
                            {{ expandedTaiwanLogId === log.id ? "ซ่อน" : "ดู" }}
                          </button>
                        </td>
                      </tr>
                      <tr *ngIf="expandedTaiwanLogId === log.id">
                        <td
                          colspan="7"
                          class="px-3 py-3 bg-slate-50/80 dark:bg-slate-900/50"
                        >
                          <p
                            *ngIf="log.errorMessage"
                            class="text-xs text-rose-600 mb-2"
                          >
                            {{ log.errorMessage }}
                          </p>
                          <p
                            *ngIf="log.taiwanIdAfter"
                            class="text-[11px] text-slate-500 mb-2 font-mono"
                          >
                            card_id_after: {{ log.taiwanIdAfter }}
                          </p>
                          <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
                            <div>
                              <p
                                class="text-[10px] font-bold text-slate-400 uppercase mb-1"
                              >
                                Request
                              </p>
                              <pre
                                class="text-[10px] leading-relaxed whitespace-pre-wrap break-all rounded-xl bg-white dark:bg-slate-950 border border-slate-100 dark:border-slate-800 p-3 max-h-48 overflow-y-auto custom-scrollbar"
                                >{{ log.requestPayload || "—" }}</pre
                              >
                            </div>
                            <div>
                              <p
                                class="text-[10px] font-bold text-slate-400 uppercase mb-1"
                              >
                                Response
                              </p>
                              <pre
                                class="text-[10px] leading-relaxed whitespace-pre-wrap break-all rounded-xl bg-white dark:bg-slate-950 border border-slate-100 dark:border-slate-800 p-3 max-h-48 overflow-y-auto custom-scrollbar"
                                >{{ log.responsePayload || "—" }}</pre
                              >
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                    <tr
                      *ngIf="!taiwanSyncLoading && taiwanSyncLogs.length === 0"
                    >
                      <td
                        colspan="7"
                        class="px-3 py-10 text-center text-slate-400"
                      >
                        <p class="font-medium">ยังไม่มีประวัติ sync</p>
                        <p
                          class="text-xs mt-1"
                          *ngIf="taiwanSyncStatus?.canResync"
                        >
                          กดปุ่มด้านบนเพื่อส่งครั้งแรก — ไม่ต้องมี log ก่อน
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                class="flex items-center justify-between mt-3"
                *ngIf="taiwanSyncLogsTotal > taiwanSyncLogPageSize"
              >
                <span class="text-xs text-slate-500"
                  >หน้า {{ taiwanSyncLogPage }}</span
                >
                <div class="flex gap-2">
                  <button
                    type="button"
                    (click)="taiwanSyncLogPrev()"
                    [disabled]="taiwanSyncLogPage <= 1"
                    class="px-3 py-1.5 rounded-lg text-xs font-bold border border-slate-200 dark:border-slate-700 disabled:opacity-40 cursor-pointer bg-white dark:bg-slate-800"
                  >
                    ก่อนหน้า
                  </button>
                  <button
                    type="button"
                    (click)="taiwanSyncLogNext()"
                    [disabled]="
                      taiwanSyncLogPage * taiwanSyncLogPageSize >=
                      taiwanSyncLogsTotal
                    "
                    class="px-3 py-1.5 rounded-lg text-xs font-bold border border-slate-200 dark:border-slate-700 disabled:opacity-40 cursor-pointer bg-white dark:bg-slate-800"
                  >
                    ถัดไป
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div
      class="flex-none px-6 md:px-8 py-5 border-t border-slate-100 dark:border-slate-800 flex justify-between gap-3 bg-white/95 dark:bg-slate-900/95"
    >
      <button
        *ngIf="canShowActivityHistory"
        type="button"
        (click)="openActivityHistory()"
        [disabled]="isLoading"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:border-amber-400 hover:text-amber-600 transition-colors disabled:opacity-50 inline-flex items-center gap-2 cursor-pointer"
      >
        <span class="material-icons text-base">history</span>
        ดูประวัติ
      </button>
      <div class="flex justify-end gap-3 ml-auto">
        <button
          (click)="closeModal()"
          [disabled]="isLoading"
          class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50"
        >
          ปิดหน้าต่าง
        </button>
        <button
          *ngIf="isWizardMode && wizardIndex > 0"
          type="button"
          (click)="prevStep()"
          [disabled]="isSaving"
          class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50 inline-flex items-center gap-1"
        >
          <span class="material-icons text-base">arrow_back</span>
          ย้อนกลับ
        </button>
        <button
          *ngIf="isWizardMode && !isLastWizardStep"
          type="button"
          (click)="nextStep()"
          [disabled]="
            isLoading ||
            (isQuotaCreate && (!canProceedQuotaForm || !hasQuotaToIssue))
          "
          class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-amber-900/30 transition-all disabled:opacity-50 inline-flex items-center gap-1"
        >
          ถัดไป
          <span class="material-icons text-base">arrow_forward</span>
        </button>
        <button
          *ngIf="!isReadOnly && (!isWizardMode || isLastWizardStep)"
          (click)="save()"
          [disabled]="
            isLoading ||
            isSaving ||
            (isQuotaCreate && (!canProceedQuotaForm || !hasQuotaToIssue))
          "
          class="px-8 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-amber-900/30 transition-all disabled:opacity-50"
        >
          {{
            isSaving
              ? "กำลังบันทึก..."
              : isQuotaCreate
                ? "ออกบัตร"
                : isCreate
                  ? "สร้างบัตร"
                  : isQuotaEdit
                    ? "บันทึกการแก้ไข"
                    : "บันทึกการแก้ไข"
          }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && cardId"
  [entityType]="activityEntityTypes.ParkingCard"
  [entityId]="cardId"
  title="ประวัติบัตรจอด"
  [subtitle]="'#' + cardId"
  (close)="closeActivityHistory()"
>
</app-modal-admin-activity-history>
